// extracted by mini-css-extract-plugin
export default {"homepg":"Header_homepg__XHUv8","head":"Header_head__5FnLu","animatelogo":"Header_animatelogo__PljTy","slogan":"Header_slogan__Hj8PU","head-top":"Header_head-top__WxA7H"};